import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { IUser } from '../../../../models/user.model';
import { VotingData } from '../../../../providers/voting';
import { ToastController } from 'ionic-angular';
import { IVotingQuestions } from '../../../../models/voting.model';
import { GamificationProvider } from '../../../../providers/gamification';
import { take } from 'rxjs/operators';
import { isEmpty, has, toArray } from 'lodash';
import { IUserAnswers } from '../../../../models/poll.model';
import { Subscription } from 'rxjs';
import { VotingTimerComponent } from '../voting-timer/voting-timer';
import { TranslateCodePipe } from '../../../../pipes/translate';

@Component({
  selector: 'app-voting-questions',
  templateUrl: 'voting-question.html'
})

export class VotingQuestionComponent implements OnInit {

  @Input('clientId')
  public clientId: string;

  @Input('eventId')
  public eventId: string;

  @Input('config')
  public config: any;

  @Input('votingId')
  public votingId: string;

  @Input('ponderationType')
  public ponderationType: 'email' | 'code';

  @Input('ponderationValue')
  public ponderationValue: string;

  @Input('user')
  public user: IUser;

  @Input('questions')
  public questions: IVotingQuestions;

  @Input('language')
  public language: string;

  @Output('closeModal')
  public closeModal: EventEmitter<boolean> = new EventEmitter();

  @ViewChild(VotingTimerComponent) public votingTimer: VotingTimerComponent;

  public questionsVoting: any[];
  public questionIndex: number = 0;

  public userAnswerVoting: any;

  public userHasRecord: boolean = false;

  public userPonderationSubs: Subscription;
  public userPonderation: number;

  public blockVotingQuestion: boolean = false;

  constructor(
    private votingData: VotingData,
    private toastCtrl: ToastController,
    private gamificationProvider: GamificationProvider,
    private translatePipe: TranslateCodePipe
  ) { }

  ngOnInit() {
    this.getVotingPonderationByUser();
    this.getUserAnswersFromDatabase();
    this.getQuestions();
  }

  /**
   * Get the userAnswer from database by ClientId, VotingId & userId
   * 1. If userAnswer exists assign the value to userAnswerPoll
   * 2. If not, assign empty value
  */
  public getUserAnswersFromDatabase() {
    this.votingData.getUserVotingEventAnswer(this.clientId, this.eventId, this.votingId, this.user.info.id).subscribe((userAnswer: IUserAnswers) => {
      if (!isEmpty(userAnswer)) {
        this.userHasRecord = true;
        this.userAnswerVoting = userAnswer.answers;
      } else {
        this.userAnswerVoting = {}
      }
    })
  }

  private getVotingPonderationByUser() {
    this.userPonderationSubs = this.votingData.getVotingPonderationByUserId(this.clientId, this.votingId, this.ponderationType, this.ponderationValue)
      .subscribe((userPonderation) => {
        this.userPonderation = userPonderation;
      });
  }

  /**
   * Get userAnswer
   * 1. Check if userAnswerVoting is not empty, and has the questionId attribute
   * 2. If yes, return the value of the questionId attribute
   * @param questionId
   * @author Sebastián Guevara
   */
  public getUserAnswer(questionId: string) {
    if (!isEmpty(this.userAnswerVoting) && has(this.userAnswerVoting, questionId)) {
      return this.userAnswerVoting[questionId];
    }
  }

  /**
   * Convert to array an specific object
   * @param object
   * @author Sebastián Guevara
   */
  public convertToArray(object) {
    return toArray(object);
  }

  /**
   * Asign the questions to questionsVoting
   * @author Sebastián Guevara
   */
  public getQuestions() {
    this.questionsVoting = this.convertToArray(this.questions);
  }

  /**
   * Get the current question based on the current question index
   * @author Sebastián Guevara
   */
  public getCurrentQuestion() {
    return this.questionsVoting[this.questionIndex];
  }

  /**
   * Mofify the index of the question
   * @param operation
   * @param
   */
  public modifyIndex(operation: string, $event) {
    switch (operation) {
      case 'previous':
        if (this.questionIndex - 1 >= 0) {
          this.questionIndex -= 1;
        }
        break;
      case 'next':
        this.userAnswerVoting[$event.id] = $event.value;
        if (this.questionIndex + 1 <= this.questionsVoting.length - 1) {
          this.questionIndex += 1;
          if (!this.userHasRecord) {
            this.votingTimer.configureStartCoundown();
          }
        } else {
          this.saveAnswer();
        }
        break;
    }
  }

  public isButtonShowing(operation: string) {
    switch (operation) {
      case 'previous':
        if (this.questionIndex === 0) {
          return false;
        } else {
          return true;
        }
      case 'next':
        if (this.questionIndex === this.questionsVoting.length - 1) {
          return false;
        }
        return true;
    }
  }

  public itLastQuestion() {
    return this.questionIndex === this.questionsVoting.length - 1
  }

  public blockVoting(event) {
    this.blockVotingQuestion = event;
  }

  public saveAnswer() {
    if (!this.userHasRecord) {
      this.votingData.saveEventVotingAnswer(this.clientId, this.eventId, this.votingId,
        this.user.info.id, this.userPonderation, this.userAnswerVoting).pipe(
          take(1)
        ).subscribe(async pollAnswer => {
          this.gamificationProvider.applyPoints(this.clientId, this.user.info.id, 'polls');
          if (this.user.info.partnerId) this.gamificationProvider.applyPointsPartner(this.clientId, this.user.info.partnerId, this.user.info.id, 'polls');

          this.toastCtrl.create({
            message: await this.translatePipe.transform('Thanks for share your opinion'),
            duration: 3000
          }).present();
          this.closeModal.emit(true);
        })
    } else {
      this.closeModal.emit(true);
    }
  }


}



// WEBPACK FOOTER //
// ./src/pages/voting/components/voting-question/voting-question.ts